/**
 * Global product type definitions
 */
export enum ProductType {
  TRADITIONAL_LOAN = "traditional_loan",
  CREDIT_BUILDER = "credit_builder",
  COMMUNITY_LOAN = "community_loan",
  COMMUNITY_LOAN_EXTENDED = "community_loan_extended"
} 